/**********************************************************
Mowing List: Lists all fert apps
3/24/20
**********************************************************/
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const propTypes = {
  mowingRecords: PropTypes.array,
  onClick: PropTypes.func
};

const MowingAppList = ({ mowingRecords, employees, onClick }) => {
  if (!mowingRecords) return <span>No Applications Available</span>;
  return (
    <div className="card">
      <ul className="collection">
        {
          mowingRecords.map((m) => (
            <li key={m.mowAppId} className="collection-item chem-list-item"
              onClick={() => onClick({ formId: 'mowing-form', app: m, employees })}>
              <span><b>{ moment(m.date).format('MM/DD/YYYY') }</b></span><br />
              <div className="fert-flex-list">
                {
                  m.mowJobs.map((f) => {
                    return (
                      <span key={`${f.id}${Math.random()}`}>
                        <span className="icon-shift">{ f.field }</span>
                      </span>
                    )
                  })
                }
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

MowingAppList.propTypes = propTypes;
export default MowingAppList;


/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/mowing/mowing_list.js